import React from 'react';
import { Link } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Badge } from 'antd';

import { ENotificationType } from 'v2/interfaces/notification';
import notificationService from 'v2/services/notifications';

export default function Comission() {
  const [notifications] = useObservable(() => notificationService.getListGroupNotifications(), []);

  const comissions = (notifications || []).find(n => n.type === ENotificationType.COMISSION);
  if (!comissions?.quantity) return null;

  return (
    <Link to={`/producer/notifications/${ENotificationType.COMISSION}`}>
      <div className='flex items-center justify-between px-4 py-2.5 transition-colors hover:bg-[#f5f5f5]'>
        <span className='text-sm font-medium text-[#37474f]'>Nova Comissão</span>
        <Badge count={comissions?.quantity || 0} color='blue' showZero />
      </div>
    </Link>
  );
}
